import React from 'react'
import { Button } from "@mui/material";

interface Props {
    text: string
    color: string | undefined
    onClick: () => void
    disabled: boolean
}

const FullWidthMobileButton:React.FC<Props> = ({text, color, onClick, disabled }) => {
    return (
        <Button
            variant="contained"
            color={color}
            style={{
                width: "100%",
                padding: "6px 0",
                fontSize: "22px"
            }}
            onClick={onClick}
            disabled={disabled}
        >
            {text}
        </Button>)
}
export default FullWidthMobileButton